import React, { useEffect, useContext } from 'react';
import { Highlight, useHits, useInstantSearch } from 'react-instantsearch';
import GtmContext from '../../contexts/GtmContext';
import { pushToDataLayer } from '@jbhi-fi/utils/src/ga4Tracking/datalayer';
import { useFeatureFlag } from '../../hooks/useFeatureFlag/useFeatureFlag';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import { SearchPlaceholderList } from './SearchPlaceholderList';

const Categories = () => {
  const { results: searchResults } = useHits();
  const { status } = useInstantSearch();
  const isSearchStalled = status === 'stalled';
  const isSearching = status === 'loading';
  const { gtm, setGtm } = useContext(GtmContext);
  const hits = searchResults && searchResults.hits;
  const hasResults = searchResults && searchResults.nbHits !== 0;
  const hasNoResults = searchResults && searchResults.nbHits === 0 && !isSearching && !isSearchStalled;
  const isNewSearch = useFeatureFlag('isSearchOverlayNewDesign');
  const categoriesLimit = isNewSearch ? 4 : 3;
  const isDesktop = useBreakpoint('md', 'up');
  const { query } = searchResults;

  useEffect(() => {
    if (hasResults) {
      setGtm({
        ...gtm,
        suggestions: {
          ...gtm.suggestions,
          category: hits.slice(0, categoriesLimit).map((c, i) => ({
            label: c.title,
            position: i + 1,
          })),
        },
      });
    } else {
      setGtm({
        ...gtm,
        suggestions: {
          ...gtm.suggestions,
          category: undefined,
        },
      });
    }
  }, [hasResults]);

  const clickGtmHandler = (e, hit, i) => {
    window.dataLayer.push({
      ...gtm,
      event: 'custom.search.suggested.click',
      label: hit.title,
      suggestions: {},
      suggestion: {
        type: 'category',
        label: hit.title,
        position: i + 1,
      },
      products: [],
    });

    pushToDataLayer({
      event: 'click_category',
      search_term: query,
      search_type: 'suggested search',
      label: hit?.title,
      info: {
        url: e?.currentTarget?.href,
      },
      method: 'undefined',
      filters: {},
    });
  };

  if (hasNoResults && !isDesktop) return;

  return (
    <div className="categories">
      <CalloutFont as="h3">Categories</CalloutFont>
      {hasResults ? (
        <ul>
          {hits.slice(0, categoriesLimit).map((hit, i) => {
            return (
              <li key={hit.objectID}>
                <a href={`/collections/${hit.url}`} onClick={e => clickGtmHandler(e, hit, i)}>
                  <Highlight hit={hit} attribute="title" highlightedTagName="em" />
                </a>
              </li>
            );
          })}
        </ul>
      ) : hasNoResults ? (
        <ul>
          <li>No results</li>
        </ul>
      ) : (
        <SearchPlaceholderList length={categoriesLimit} />
      )}
    </div>
  );
};

export default Categories;
